import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ClientApplicationForm, {
  ClientApplicationFormRef,
  ClientApplicationValues,
} from './ClientApplicationForm';

type CreateClientApplicationModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: ClientApplicationValues) => Promise<void>;
};

const CreateClientApplicationModal: React.FC<
  CreateClientApplicationModalProps
> = ({ isOpen, toggle, onSubmit }) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ClientApplicationFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ClientApplicationValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
      formRef.current?.reset();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['company.clientApplication.addNewTitle']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <ClientApplicationForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateClientApplicationModal;
